<template>
	<div class="dialogCreateFile">
		<dialogTitle name="方案信息" />
		<el-form
			:model="ruleForm"
			:rules="rules"
			ref="ruleForm"
			label-width="100px"
			class="demo-ruleForm"
		>
			<el-form-item label="业务类型">
				<span>{{ itemByNeedNo.channelTypeName }}</span>
				<!-- <el-radio-group v-model="ruleForm.bizType">
					<el-radio label="icpsq">ICP申请</el-radio>
					<el-radio label="edisq">EDI申请</el-radio>
				</el-radio-group> -->
			</el-form-item>
			<el-form-item label="办理类型">
				<el-radio-group v-model="ruleForm.actionType">
					<el-radio label="新办">新办</el-radio>
					<el-radio label="年检">年检</el-radio>
					<el-radio label="变更">变更</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="企业名称" prop="name">
				<el-input
					v-model="ruleForm.name"
					placeholder="请输入企业名称"
				></el-input>
			</el-form-item>
			<el-form-item label="申请区域" prop="region">
				<el-select
					v-model="ruleForm.region"
					placeholder="请选择申请区域"
					@change="regionchange"
				>
					<el-option
						v-for="(item, index) in regionList"
						:key="index"
						:label="item"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="方案价格">
				<p class="price">￥{{ (Number(price) / 100).toFixed(2) }}</p>
			</el-form-item>
			<el-form-item label="公司地址" prop="city">
				<v-distpicker
					v-model="ruleForm.city"
					@province="selectProvince"
					@city="selectCity"
				/>
			</el-form-item>
			<el-form-item label="" prop="address">
				<el-input
					v-model="ruleForm.detailAddress"
					placeholder="请输入详细地址"
				></el-input>
			</el-form-item>
		</el-form>
		<div class="demantFromFooter">
			<el-button type="primary" @click="submitForm('ruleForm')"
				>立即创建</el-button
			>
		</div>
	</div>
</template>

<script>
//
import dialogTitle from './dialogtitle'
import { submitIcpProgramme, getaliicpProduce } from '@/api/alicp.js'
export default {
	props: ['itemByNeedNo'],
	components: {
		dialogTitle,
	},
	data() {
		return {
			ruleForm: {
				name: '',
				region: '',
				province: '',
				city: '',
				detailAddress: '',
				bizType: 'icpsq',
				actionType: '新办', //新办，年检，变更
			},
			price: 0,
			rules: {
				name: [
					{
						required: true,
						message: '请输入企业名称',
						trigger: 'blur',
					},
				],
				region: [
					{
						required: true,
						message: '请选择申请区域',
						trigger: 'change',
					},
				],
				city: [
					{
						required: true,
						message: '请选择省市',
						trigger: 'change',
					},
				],
				address: [
					{
						required: false,
						message: '请输入详细地址',
						trigger: 'blur',
					},
				],
			},
			regionList: [
				'外资',
				'北京',
				'上海',
				'福建',
				'广西',
				'广东',
				'安徽',
				'河南',
				'湖北',
				'浙江',
				'江苏',
				'山东',
				'陕西',
				'宁夏',
				'甘肃',
				'新疆',
				'青海',
				'天津',
				'重庆',
				'河北',
				'山西',
				'辽宁',
				'吉林',
				'黑龙江',
				'江西',
				'湖南',
				'四川',
				'贵州',
				'云南',
				'内蒙古',
				'西藏',
				'香港',
				'海南',
			],
		}
	},
	watch: {
		// 'itemByNeedNo.channelTypeName': {
		// 	handler(val) {
		// 		this.ruleForm.bizType = val
		// 	},
		// 	deep: true,
		// },
	},
	mounted() {},
	methods: {
		selectProvince(a) {
			this.ruleForm.province = a.value
			this.ruleForm.city = ''
		},
		selectCity(a) {
			this.ruleForm.city = a.value
		},
		submitForm(formName) {
			console.log(this.ruleForm)
			let obj = {
				CompanyName: this.ruleForm.name,
				Area: this.ruleForm.region,
				CompanyAddress:
					this.ruleForm.province +
					this.ruleForm.city +
					this.ruleForm.detailAddress,
				Note: '',
				ActionType: this.ruleForm.actionType,
			}
			console.log(obj, 'obj')
			if (
				!this.ruleForm.province ||
				!this.ruleForm.province ||
				!this.ruleForm.detailAddress
			) {
				this.$message({
					message: '请完善信息',
					type: 'warning',
				})
				return
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$emit('tolkParent', { loading: true, dialog: true })
					submitIcpProgramme(
						obj,
						this.$route.query.needNo,
						this.ruleForm.bizType
					).then((res) => {
						console.log(res)
						if (res.status == 0) {
							this.$message({
								message: '创建方案成功！',
								type: 'success',
							})
							this.$emit('tolkParent', {
								loading: false,
								dialog: false,
							})
							this.ruleForm = {
								name: '',
								region: '',
								province: '',
								city: '',
								detailAddress: '',
							}
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
							})
							this.$emit('tolkParent', {
								loading: false,
								dialog: true,
							})
						}
					})
				} else {
					this.$message({
						message: '请完善信息',
						type: 'warning',
					})
					return false
				}
			})
		},
		regionchange(val) {
			let params = {
				channelTypeCode: this.itemByNeedNo.channelTypeCode,
				province: val,
			}
			getaliicpProduce(params).then((res) => {
				if (res.status == 0) {
					this.price = res.data.price
				} else {
					this.price = 0
				}
			})
		},
	},
}
</script>

<style lang="scss">
.dialogCreateFile {
	width: 100%;
	.el-form {
		width: 100%;
		.el-form-item {
			.el-form-item__content {
				.el-input {
					width: 190px;
					margin-right: 10px;
				}
				& > .el-input {
					width: 400px;
				}
				.el-input__inner:focus {
					border-color: #ff8a01;
				}
				.price {
					font-size: 18px;
					color: #ff8a01;
					font-weight: 500;
				}
			}
		}
	}
	.distpicker-address-wrapper select {
		width: 190px;
	}
	.distpicker-address-wrapper select:nth-child(3) {
		display: none;
	}
	.demantFromFooter {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		.el-button {
			background: #ff8a01;
			border: none;
		}
	}
	.el-radio__input.is-checked .el-radio__inner {
		border-color: #ff8a01;
		background: #ff8a01;
	}
	.el-radio__input.is-checked + .el-radio__label {
		color: #ff8a01;
	}
}
</style>
